import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadCustomerUsageGraphsBlockData from 'Models/Content/AbroadCustomerUsageGraphsBlockData';
import AbroadCustomerUsageGraphsMain from './AbroadCustomerUsageGraphsMain';

export default class AbroadCustomerUsageGraphsBlock extends EpiComponent<AbroadCustomerUsageGraphsBlockData> {
  public render(): ReactNode | null {
    return <AbroadCustomerUsageGraphsMain iContent={this.props.data} context={this.getContext()} />;
  }
}
